import { BannerHomepageModule } from '../../models/home-page-custom/types';
import { useLinkClickHandler } from '../../hooks/useLinkClickHandler';

const getSizeClass = (
  size: 'ExtraSmall' | 'Small' | 'Medium' | 'Large' | undefined
): string => {
  switch (size) {
    case 'ExtraSmall':
      return 'home__banner--extra-small';
    case 'Small':
      return 'home__banner--small';
    case 'Medium':
      return 'home__banner--medium';
    case 'Large':
      return 'home__banner--large';
    default:
      return 'home__banner--medium'; // Default to medium
  }
};

export const HomepageBanner = ({
  bannerModule,
}: {
  bannerModule: BannerHomepageModule;
}) => {
  const size = bannerModule?.attributes.settings?.size;
  const sizeClass = getSizeClass(size);
  const imageUrl = bannerModule?.attributes.settings?.image_url;

  const { handleClick, handleKeyDown, normalizedUrl } =
    useLinkClickHandler(imageUrl);

  const bannerContent = (
    <img
      src={bannerModule?.attributes.settings?.web_image}
      alt={bannerModule?.attributes.settings?.aria_label}
    />
  );

  // If there's an image_url, render as a link
  if (normalizedUrl) {
    return (
      <a
        href={normalizedUrl}
        className={`home__banner ${sizeClass}`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        {bannerContent}
      </a>
    );
  }

  // Otherwise, render as a div
  return <div className={`home__banner ${sizeClass}`}>{bannerContent}</div>;
};
